// src/components/PeoplePlan/Tables/CrewMemberTable.js
import React from "react";
import GenericEmployeeTable from "../EmployeeManagement/GenericEmployeeTable";
import { ROLE_CONFIGS } from "../configs/roleConfigs";

function CrewMemberTable({ selectedMUM, storeData, onNavigateToProfile }) {
  return (
    <GenericEmployeeTable
      selectedMUM={selectedMUM}
      storeData={storeData}
      roleConfig={ROLE_CONFIGS.CREW_MEMBER}
      onNavigateToProfile={onNavigateToProfile}
      enableSorting={true} // Crew members have sorting enabled
    />
  );
}

export default CrewMemberTable;